import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAgeRangeMask]'
})
export class AgeRangeMaskDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const formattedValue = value
      .replace(/\D/g, '') // Remove non-numeric characters
      .replace(/(\d{0,3})(\d{0,3})?(\d{0,3})?/, (match, p1, p2, p3) => {
        let result = '';
        if (p1) {
          result += 'from ' + p1;
        }
        if (p2) {
          result += ' to ' + p2;
        }
        if (p3) {
          result += ' to ' + p3;
        }
        return result.trim();
      });
    this.ngControl.valueAccessor?.writeValue(formattedValue);
  }

}
